<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Farm</a></li>
          <li><a>Transactions Report</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg"
                                     title="Home"></a>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Transactions Report</span>
      </div>
      <div class="Reports_form_div">
        <form role="form" name="addmapdevice" [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                          [(ngModel)]="transaction.farm_site_id"
                          (selectionChange)="getSetionsByFarmsiteId(transaction.farm_site_id)">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                <i *ngIf="f.locationField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div">
          <div class="transactions-button-container" (click)="transactionRegister()">
            <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
              <span class="text">Search</span>
            </button>
          </div>
        </div>
      </div>
      <!--loader-->
      <div *ngIf="responseLoader">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!--loaderend-->
    </div>
    <div class="block">
      <!--Table data-->
      <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked">
        <div class="reports-toolbar">
          <!-- Search -->
          <div class="reports-toolbar__search">
            <img src="assets/images/New_Icons/search-icon.svg" alt="Search Icon"/>
            <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off"
                   placeholder="Search by section, tank, item and transaction type name"/>
            <button *ngIf="search !== ''" type="button" (click)="clearFilters('search')" class="reports-toolbar__clear-btn" style="top: 10px" title="Clear search" >&times;</button>
          </div>
          <div class="filter_selection_div">
            <div style="position: relative;">
              <button class="filter_button"
                      (click)="onFilterChange()">{{ isItemTypeSelected || isDateRangeSelected || isTransactionTypeSelected ? 'Clear Filters' : 'Apply Filters' }}
              </button>
              <button *ngIf="(isItemTypeSelected || isDateRangeSelected || isTransactionTypeSelected) || filterType == ''"
                      type="button" (click)="clearFilters('')" title="clear Filters"
                      class="searchClose filtersCloseBlock ">&times;
              </button>
            </div>
          </div>
          <!-- Actions -->
          <div class="reports-toolbar__actions" *ngIf="transactions?.length > 0">
            <img src="assets/images/New_Icons/excel-download-icon.svg" title="Excel export" (click)="exportExcel()"/>
            <img src="assets/images/New_Icons/expand-icon.svg" title="Zoom In" (click)="openFullScreen()"/>
          </div>
        </div>
        <div class="reports-form-container" *ngIf="filterType == ''">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Section</mat-label>
            <mat-select id="section" [(ngModel)]="transaction.section_id"
                        (selectionChange)="getPondsBySectionId();isSectionSelected = true;onFiltersApplied()">
              <mat-option value="undefined" disabled>Select Sections</mat-option>
              <mat-option *ngFor="let sections of pondSections" [value]="sections.id"> {{ (sections?.section_name) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--Pond-->
          <mat-form-field appearance="outline" class="w-100" *ngIf="customerPonds && customerPonds.length > 0">
            <mat-label>Ponds</mat-label>
            <mat-select id="pond" [(ngModel)]="transaction.pond_id"
                        (selectionChange)="isPondSelected = true;onFiltersApplied()">
              <mat-option value="undefined" disabled>Select Ponds</mat-option>
              <mat-option *ngFor="let sections of customerPonds"
                          [value]="sections.pond_id"> {{ (sections?.pond_name) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--item type-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Item type</mat-label>
            <mat-select id="itemtype" [(ngModel)]="isInventory"
                        (selectionChange)="isItemTypeSelected = true;onFiltersApplied()">
              <mat-option value="undefined" disabled>Select Item type</mat-option>
              <mat-option value="1">Inventory</mat-option>
              <mat-option value="0">Expense</mat-option>
            </mat-select>
          </mat-form-field>
          <!--transaction type id-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Transaction Type</mat-label>
            <mat-select id="TransactionType" [(ngModel)]="transaction.transaction_type_id"
                        (selectionChange)="isTransactionTypeSelected = true;onFiltersApplied()">
              <mat-option value="undefined" disabled>Select Transaction Type</mat-option>
              <mat-option value="3" [hidden]="transaction.section_id == undefined">Issue(-)</mat-option>
              <mat-option [hidden]="transaction.section_id != undefined"
                          *ngFor="let transactiontype of transactionTypes"
                          [value]="transactiontype.id"> {{ (transactiontype.transaction_type) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--date-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>By Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeForm" [max]="maxDate"
                                  (focus)="picker.open()" (click)="picker.open()">
              <input matStartDate placeholder="Start date" formControlName="start" readonly/>
              <input matEndDate placeholder="End date" formControlName="end" readonly/>
            </mat-date-range-input>
            <!-- Dynamic icon: calendar or clear (×) -->
            <button mat-icon-button matSuffix [ngClass]="isDateRangeSelected ? 'reports-toolbar__clear-btn' : ''"
                    [ngStyle]="{ 'z-index': 1000, 'position': 'relative', 'background': 'none', 'border': 'none', 'box-shadow': 'none', 'outline': 'none' }"
                    (click)="isDateRangeSelected ? clearDateRange() : picker.open()" aria-label="Toggle date">
              <!-- Show normal calendar icon if no filter applied -->
              <mat-icon *ngIf="!isDateRangeSelected">calendar_today</mat-icon>
              <!-- Show × if filter is applied -->
              <span *ngIf="isDateRangeSelected" style="font-size: 20px; font-weight: bold;">&times;</span>
            </button>
            <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="table-responsive" id="zoomView" *ngIf="transactions?.length > 0">
          <table class="table table-bordered table-responsive-md table-striped">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingTanks('date')">Date
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':transactionregisterAsc,'glyphicon-chevron-down':!transactionregisterAsc}"></span>
              </th>
              <th>Section Name</th>
              <th>Tank Name</th>
              <th class="handSymbol" (click)="sortingTanks('itemname')">Item Name<span class="glyphicon sort-icon"
                                                                                       [ngClass]="{'glyphicon-chevron-up':transactionregisterAsc,'glyphicon-chevron-down':!transactionregisterAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingTanks('transactiontype')">Transaction Type
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':transactionregisterAsc,'glyphicon-chevron-down':!transactionregisterAsc}"></span>
              </th>
              <th>Quantity</th>
              <th>Unit Cost</th>
              <th>Total Cost</th>
              <th>GST (%)</th>
              <th>GST value</th>
              <th>Stage</th>
              <th style="width: 30px;">Comment</th>
              <th style="width: 30px;">Attachments</th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let list of transactions; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ list && list.transaction_date | date:"dd MMM yyyy" }}</td>
              <td>{{ (list && list.section_name == null) ? 'NA' : list && list.section_name }}</td>
              <td>{{ (list && list.tank_name == null) ? 'NA' : list && list.tank_name }}</td>
              <td>{{ list && list.item_name }} <span *ngIf="list && list.sub_type">-</span> {{ list && list.sub_type }}
              </td>
              <td>{{ list && list.transaction_type }}</td>
              <td class="number-align-right">{{ list && list.quantity }} {{ list && list.uomname }}</td>
              <td class="number-align-right">{{ list && list.unit_cost }}</td>
              <td class="number-align-right">{{ list && list.total_cost }}</td>
              <td class="number-align-right">{{ list && list.gst_percent || 'NA' }}</td>
              <td class="number-align-right">{{ list && list.gst_value || 'NA' }}</td>
              <td>{{ list && list.stage }}</td>
              <td>{{ (list && list.comments == null) ? '--' : (list && list.comments) }}</td>
              <td>{{ (list && list.file_name == null) ? '--' : (list && list.file_name) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <!-- Show only if filters/search applied and no data -->
        <div *ngIf="transactions?.length <= 0 && isSubmitClicked && (search || isItemTypeSelected || isDateRangeSelected || isTransactionTypeSelected)" class="noDataFoundMessage">
          {{ search && (isItemTypeSelected || isDateRangeSelected || isTransactionTypeSelected) ?
          'No items match your search and filter' :
          (search ? 'No items match your search' : 'No items match your filter') }}
        </div>

      </div>
      <div class="reports_block" *ngIf="transactions?.length <= 0 && isSubmitClicked && !(search || isItemTypeSelected || isDateRangeSelected || isTransactionTypeSelected)">
        <div class="noDataFoundMessage">Data Not Available</div>
      </div>


      <!-- End Table data-->
    </div>
  </div>
</div>
